/* PMSTEEL · Interactive sticky add-to-cart.
   Visibility: shows once the main product buy box scrolls out of view.
   Controls: quantity stepper + variant <select> (price/availability sync).
   Add: AJAX to the Cart API with Dawn's Section Rendering, refreshing the
   cart drawer / notification in place. Falls back to a native POST if JS
   or the drawer is unavailable. */
(function () {
  var form = document.querySelector('[data-pmsteel-sticky]');
  if (!form) return;

  var addBtn = form.querySelector('[data-sticky-add]');
  var addText = form.querySelector('[data-sticky-add-text]');
  var priceEl = form.querySelector('[data-sticky-price]');
  var variantSel = form.querySelector('[data-sticky-variant]');   // <select>, multi-option products
  var swatches = form.querySelector('[data-sticky-swatches]');    // radio swatches, color-only products
  var thumbImg = form.querySelector('[data-sticky-img]');
  var qtyInput = form.querySelector('[data-qty-input]');
  var minus = form.querySelector('[data-qty-minus]');
  var plus = form.querySelector('[data-qty-plus]');
  var status = document.getElementById(form.getAttribute('data-sticky-status-id'));
  var error = document.getElementById(form.getAttribute('data-sticky-error-id'));

  function setFeedback(type, message) {
    if (status) status.textContent = type === 'status' ? message : '';
    if (error) error.textContent = type === 'error' ? message : '';
  }

  function getErrorMessage(data) {
    if (data && typeof data.description === 'string' && data.description.trim()) return data.description;
    if (data && typeof data.message === 'string' && data.message.trim()) return data.message;
    return form.getAttribute('data-sticky-error-message') || '';
  }

  /* ---- quantity stepper ---- */
  function clampQty(v) {
    v = parseInt(v, 10);
    if (isNaN(v) || v < 1) v = 1;
    return v;
  }
  if (qtyInput) {
    if (minus) minus.addEventListener('click', function () { qtyInput.value = clampQty(qtyInput.value) - 1 || 1; });
    if (plus) plus.addEventListener('click', function () { qtyInput.value = clampQty(qtyInput.value) + 1; });
    qtyInput.addEventListener('change', function () { qtyInput.value = clampQty(qtyInput.value); });
  }

  /* ---- variant selection: works for both the <select> and the swatch radios ---- */
  function currentOpt() {
    if (variantSel) return variantSel.options[variantSel.selectedIndex];
    if (swatches) return swatches.querySelector('input:checked');
    return null;
  }

  function selectById(id) {
    if (variantSel) {
      for (var i = 0; i < variantSel.options.length; i++) {
        if (variantSel.options[i].value === id) { variantSel.selectedIndex = i; return true; }
      }
    } else if (swatches) {
      var inputs = swatches.querySelectorAll('input');
      for (var j = 0; j < inputs.length; j++) {
        if (inputs[j].value === id) { inputs[j].checked = true; return true; }
      }
    }
    return false;
  }

  function refreshFromSelected() {
    var opt = currentOpt();
    if (!opt) return;
    if (priceEl && opt.dataset.price) priceEl.textContent = opt.dataset.price;
    if (thumbImg && opt.dataset.img) thumbImg.src = opt.dataset.img;
    var available = opt.dataset.available === 'true';
    addBtn.disabled = !available;
    if (addText) addText.textContent = available ? 'Add to cart' : 'Sold out';
  }

  /* Sticky → main picker: mirror the chosen variant's option values onto Dawn's
     variant-selects (radios/pills/swatches or dropdowns), then fire ONE change
     event so product-info re-renders price/media/URL exactly as if the user had
     used the main picker. */
  function syncMainPicker(opt) {
    var varSelects = document.querySelector('variant-selects');
    if (!varSelects || !opt || !opt.dataset.options) return;
    var values;
    try { values = JSON.parse(opt.dataset.options); } catch (err) { return; }
    var groups = varSelects.querySelectorAll('.product-form__input');
    var lastChanged = null;
    values.forEach(function (value, i) {
      var group = groups[i];
      if (!group) return;
      var select = group.querySelector('select');
      if (select) {
        if (select.value !== value) { select.value = value; lastChanged = select; }
        return;
      }
      var radios = group.querySelectorAll('input[type="radio"]');
      for (var r = 0; r < radios.length; r++) {
        if (radios[r].value === value) {
          if (!radios[r].checked) { radios[r].checked = true; lastChanged = radios[r]; }
          break;
        }
      }
    });
    if (lastChanged) lastChanged.dispatchEvent(new Event('change', { bubbles: true }));
  }

  var picker = variantSel || swatches;
  if (picker) {
    picker.addEventListener('change', function () {
      refreshFromSelected();
      syncMainPicker(currentOpt());
    });

    /* Main picker → sticky: follow Dawn's variant-change event. Setting values
       programmatically fires no change event, so this cannot loop back. */
    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      subscribe(PUB_SUB_EVENTS.variantChange, function (event) {
        var variant = event && event.data && event.data.variant;
        if (!variant) return;
        var id = String(variant.id);
        var cur = currentOpt();
        if (cur && cur.value === id) return;
        if (selectById(id)) refreshFromSelected();
      });
    }
  }

  /* ---- visibility: reveal once the buy box's RESTING position is scrolled past.
     The buy box sits in Dawn's sticky product-info column, so it can stay pinned
     on screen for the whole product section — observing its live visibility fires
     far too late. Compare scroll position against where it rests in the document
     instead. ---- */
  var anchor = document.querySelector('.product-form__buttons') || document.querySelector('product-form');
  var threshold = 520;
  function measure() {
    if (!anchor) return;
    // Only measure while above the current threshold — past it, the sticky
    // column may be pinned, which would poison the measurement.
    if (window.scrollY > threshold) return;
    var r = anchor.getBoundingClientRect();
    threshold = r.bottom + window.scrollY;
  }
  function onScroll() { form.classList.toggle('is-visible', window.scrollY > threshold); }
  measure();
  onScroll();
  window.addEventListener('load', function () { measure(); onScroll(); });
  window.addEventListener('resize', function () { measure(); onScroll(); }, { passive: true });
  window.addEventListener('scroll', onScroll, { passive: true });

  /* ---- iOS sticky-bar note (STICKY-0001, reverted 07-20) ----
     The bar drifts up when Safari's chrome collapses because position:fixed anchors to the
     LAYOUT viewport. A visualViewport-driven `bottom` compensation was tried and made it
     WORSE on device (clipped the bar off-screen), so it was reverted to plain bottom:0.
     Proper fix needs on-device iteration; do NOT reintroduce blind. */

  /* ---- AJAX add via Cart + Section Rendering API (Dawn-native) ---- */
  function drawer() { return document.querySelector('cart-drawer'); }
  function notification() { return document.querySelector('cart-notification'); }

  form.addEventListener('submit', function (e) {
    var cd = drawer();
    var cn = notification();
    // If Dawn's cart drawer/notification isn't present, let the native POST to /cart proceed.
    if (!cd && !cn) return;
    if (!window.fetch) return;
    e.preventDefault();

    var failed = false;
    setFeedback('', '');
    addBtn.setAttribute('aria-busy', 'true');
    addBtn.disabled = true;

    // Derive the sections to re-render from the host element itself, so this works
    // for either the cart drawer or the cart notification without hard-coding IDs.
    var host = cd || cn;
    var sectionIds = 'cart-icon-bubble';
    if (host && typeof host.getSectionsToRender === 'function') {
      sectionIds = host.getSectionsToRender().map(function (s) { return s.id; }).join(',');
    }

    var body = new FormData(form);
    body.append('sections', sectionIds);
    body.append('sections_url', window.location.pathname);

    fetch(form.getAttribute('action'), {
      method: 'POST',
      headers: { Accept: 'application/json' },
      body: body
    })
      .then(function (response) {
        return response.json().then(function (data) {
          return { ok: response.ok, data: data };
        });
      })
      .then(function (result) {
        var data = result.data;
        if (!result.ok || data.status) {
          failed = true;
          setFeedback('error', getErrorMessage(data));
          return;
        }
        setFeedback('status', form.getAttribute('data-sticky-success-message') || '');
        if (host && typeof host.renderContents === 'function') {
          host.renderContents(data); // Dawn opens the drawer/notification itself
        } else {
          window.location = '/cart';
        }
      })
      .catch(function () {
        failed = true;
        setFeedback('error', getErrorMessage());
      })
      .finally(function () {
        addBtn.removeAttribute('aria-busy');
        var opt = currentOpt();
        addBtn.disabled = opt ? opt.dataset.available !== 'true' : false;
        if (failed) addBtn.focus();
      });
  });
})();
